import { Typography } from "@mui/material";
import { ContentContainer } from "./ContentContainer";
import { SubSectionHeader } from "./SubSectionHeader";

export const AboutMe = () => {
  return (
    <ContentContainer id="aboutMe">
      <div style={{ textAlign: "left" }}>
        <SubSectionHeader title="About me" subtitle="A little bit about me" />
        <Typography variant="body1" marginTop={1}>
          I'm a Software Engineer passionate about building impactful products
          and solving interesting problems.
          <br />
          <br />
          I have experience working across multiple tech stacks, with a primary
          focus on React, TypeScript, and AWS infrastructure. In my free time, I
          love exploring new technical frameworks and working on personal
          projects.
          <br />
          <br />
          I completed a degree in Bachelor of Computing at University of Sydney
          with a major in Computational Data Science. While studying I've
          participated in multiple student societies - BusinessOne Consulting,
          Sydney Consulting Society, and USYD CommStem.
          <br />
          <br />
          Outside of coding, I've been grinding Ticket to Ride and Terraforming
          Mars. I love strategy games so if you have any recs, plz let me know!
          <br />
        </Typography>
      </div>
    </ContentContainer>
  );
};
